import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Svg from "_assets/svg";
import { useHistory, useLocation } from "react-router-dom";
import Chevron from "./Chevron";
import ChildMenu from "./ChildMenu";
import Icon from "./Icon";
import Label from "./Label";
import Section from "./Section";
import SelectedMenu from "./SelectedMenu";
import Wrapper from "./Wrapper";
import ActiveMenu from "./ActiveMenu";

const MenuSidebar = (props) => {
  const [active, setActive] = useState(false);
  const { id, child, title, icon, onClick } = props;
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const splitPath = location.pathname.split("/");
    setActive(splitPath[2] === id);
  }, []);

  const handleActive = () => {
    setActive(!active);
    return onClick && onClick();
  };

  return (
    <div className="menu-sidebar">
      <Wrapper onClick={handleActive} className="noselect">
        <Section>
          <div className="d-flex justify-content-center">
            <Icon src={icon} />
            <Label>{title}</Label>
          </div>
          <Chevron active={active} src={Svg.chevron_right.default} />
        </Section>
      </Wrapper>
      <div className="d-flex flex-row w-100 child-menu">
        <SelectedMenu />
        <div className="d-flex flex-column w-100">
          {active &&
            child?.map((val) => {
              return (
                <ChildMenu
                  key={val.id}
                  onClick={() => history.push(`/docs/${id}/${val.id}`)}
                  active={location.pathname.indexOf(`/docs/${id}/${val.id}`) >= 0}
                  className="d-flex flex-row w-100 position-relative text-nowrap"
                >
                  {location.pathname.indexOf(`/docs/${id}/${val.id}`) >= 0 && <ActiveMenu />}
                  <Label child>{val.title}</Label>
                </ChildMenu>
              );
            })}
        </div>
      </div>
    </div>
  );
};

MenuSidebar.propTypes = {
  child: PropTypes.shape([]).isRequired,
  title: PropTypes.string,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  id: PropTypes.string,
};

MenuSidebar.defaultProps = {
  title: "",
  onClick: undefined,
  id: "",
};
export default MenuSidebar;
